import { render, staticRenderFns } from "./ventanita-estados.vue?vue&type=template&id=8b687d24"
import script from "./ventanita-estados.vue?vue&type=script&lang=js"
export * from "./ventanita-estados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports